import axiosInstance from "../../services/axiosInstance";

export const importJobAPI = {
  // 列出可用的 importType 與範例 DTO
  async excelImporters() {
    try {
      const response = await axiosInstance.get(`/api/importjob/importers`);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching data:");
      console.error("Error fetching data:", error);
      return null; // 失敗時回傳 null
    }
  },

  ////////  檢查是否有進行中的匯入任務
  async checkImportJob(type) {
    try {
      const response = await axiosInstance.get(`/api/importjob/check/${type}`);
      return response.data.data;
    } catch (error) {
      // handleAPIError(error, "Error fetching data:");
      console.error("Error fetching data:", error);
      return null; // 失敗時回傳 null
    }
  },

    /////大量上傳excel
  async submitImportJob(formData) {
    try {
      const response = await axiosInstance.post(
        `/api/importjob/submit`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  ////查詢目前jobId任務進度
  async checkJobStatus(jobId) {
    try {
      const response = await axiosInstance.get(
        `/api/importjob/status/${jobId}`,
      );
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
};
